import { useTranslation } from '@shared/core';
import { EventPageType, EventPageVisibility, EventWebsiteGuestQuery, GetRegistryDataQuery } from '@graphql/generated';
import { EventFeature, useProFeature } from '@shared/hooks/useProFeature';
import { useEventInfo } from '@shared/utils/eventInfo';

export const useAppPage = () => {
  const { t: appsTranslation } = useTranslation('eventSiteApps');
  const disableAddAppPage = useProFeature(EventFeature.disableAddAppPage);
  const { eventInfo } = useEventInfo();

  const addAppPage = (eventHandle: string | undefined, event: EventWebsiteGuestQuery['eventByName'] | GetRegistryDataQuery['eventByName']) => {
    const newPages = event?.pages ? [...event.pages] : [];

    const hideDownloadAppPage = eventInfo?.settings.hideDownloadAppPage ?? false;

    if (!disableAddAppPage && !hideDownloadAppPage) {
      newPages.push({
        id: 'app',
        disabled: false,
        mobilePhoto: null,
        pageSlug: 'app',
        pageTitle: appsTranslation('title')(),
        photo: null,
        subTitle: appsTranslation('message')({ website: eventHandle }),
        type: EventPageType.app,
        isPageContainer: false,
        visibility: EventPageVisibility.public,
      });
    }

    return newPages;
  };

  return addAppPage;
};
